import { PharmacyTechPatient, PharmacyTechUpload } from '../../generated';

// Patient as returned by GET /pharmacy_tech/patient.
export type PharmacyPatient = PharmacyTechPatient;

// Upload history row as returned by GET /pharmacy_tech/{customer_id}/upload.
export type PharmacyUpload = PharmacyTechUpload;

// Issue reported by POST /pharmacy_tech/{customer_id}/upload — either a
// sanitizable syntax problem (e.g. unquoted commas inflating the column
// count) or a blocking one the server cannot repair (e.g. an empty CSV).
// Only code/label are always present; blocking issues like EMPTY_CSV carry a
// `reason` instead of affected rows.
export interface CsvIssue {
  code: string;
  label: string;
  reason?: string;
  affected_rows?: number[];
  count?: number;
  sample?: string;
  sample_repaired?: string;
}

export type MedicationUploadResult =
  | { outcome: 'success' }
  | { outcome: 'issues_found'; issues: CsvIssue[] }
  | { outcome: 'blocked'; message: string; issues: CsvIssue[] }
  | { outcome: 'error' };

export interface PharmacyPatientsStore {
  patients: PharmacyPatient[];
  uploads: PharmacyUpload[];
  error: any | null;
  isLoading: boolean;
  isUploadsLoading: boolean;
}

export enum PharmacyPatientsActionType {
  SET_PHARMACY_PATIENTS = 'SET_PHARMACY_PATIENTS',
  PHARMACY_PATIENTS_SET_LOAD_STATE = 'PHARMACY_PATIENTS_SET_LOAD_STATE',
  PHARMACY_PATIENTS_API_ERR = 'PHARMACY_PATIENTS_API_ERR',
  SET_PHARMACY_UPLOADS = 'SET_PHARMACY_UPLOADS',
  PHARMACY_UPLOADS_SET_LOAD_STATE = 'PHARMACY_UPLOADS_SET_LOAD_STATE',
}

export interface SetPharmacyPatientsAction {
  type: PharmacyPatientsActionType.SET_PHARMACY_PATIENTS;
  payload: { patients: PharmacyPatient[] };
}

export interface SetPharmacyPatientsLoadStateAction {
  type: PharmacyPatientsActionType.PHARMACY_PATIENTS_SET_LOAD_STATE;
  payload: { isLoading: boolean };
}

export interface PharmacyPatientsApiErrorAction {
  type: PharmacyPatientsActionType.PHARMACY_PATIENTS_API_ERR;
  payload: { error: any };
}

export interface SetPharmacyUploadsAction {
  type: PharmacyPatientsActionType.SET_PHARMACY_UPLOADS;
  payload: { uploads: PharmacyUpload[] };
}

export interface SetPharmacyUploadsLoadStateAction {
  type: PharmacyPatientsActionType.PHARMACY_UPLOADS_SET_LOAD_STATE;
  payload: { isUploadsLoading: boolean };
}

export type PharmacyPatientsAction =
  | SetPharmacyPatientsAction
  | SetPharmacyPatientsLoadStateAction
  | PharmacyPatientsApiErrorAction
  | SetPharmacyUploadsAction
  | SetPharmacyUploadsLoadStateAction;
